<template>
    <div
        v-if="isActive"
        class="tab"
    >
        <slot :goToTab="goToTab" />
    </div>
</template>

<script>
import { computed, inject } from 'vue';
import useTabs from './use-tabs';

export default {
    name: 'tab',
    props: {
        id: {
            type: String,
            default: () => '',
            required: true,
        }
    },
    setup(props) {
        const { goToTab } = useTabs();

        const currentTab = inject('currentTab');

        return {
            goToTab,
            isActive: computed(() => currentTab.value === props.id),
        };
    }
};
</script>

